import React from 'react';

/**
 * ADS native select.
 */
const AdsSelect = ({
  value,
  onChange,
  children,
  className = '',
  compact = false,
  id,
  name,
  disabled = false,
  'aria-label': ariaLabel,
  ...props
}) => {
  const classes = ['ads-select', compact ? 'ads-select--compact' : '', className]
    .filter(Boolean)
    .join(' ');

  return (
    <select
      id={id}
      name={name}
      className={classes}
      value={value}
      onChange={onChange}
      disabled={disabled}
      aria-label={ariaLabel}
      {...props}
    >
      {children}
    </select>
  );
};

export const AdsField = ({ label, children, className = '', htmlFor }) => (
  <div className={`ads-field ${className}`.trim()}>
    {label ? (
      <label className="ads-field__label" htmlFor={htmlFor}>
        {label}
      </label>
    ) : null}
    {children}
  </div>
);

export default AdsSelect;
